/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Not_PermittedInputs */

const th_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะผู้ตัดสินของเกมนี้หรือผู้จัดอีเวนต์เท่านั้นที่ถ่ายทอดสดได้`)
};

const en_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only this game's referee or the people running the event can broadcast it.`)
};

const ja_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合を配信できるのは、担当審判と大会の運営者だけです。`)
};

const zh_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有这场比赛的裁判或主办方才能直播。`)
};

const es_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo el árbitro de este partido o quienes organizan el evento pueden retransmitirlo.`)
};

const pt_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o árbitro deste jogo ou quem organiza o evento pode transmiti-lo.`)
};

const id_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya wasit pertandingan ini atau penyelenggaranya yang boleh menyiarkannya.`)
};

const fr_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seul l’arbitre de ce match ou les organisateurs de l’événement peuvent le diffuser.`)
};

const tl_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang referee lamang ng larong ito o ang mga organizer nito ang maaaring magsahimpapawid.`)
};

const vi_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ trọng tài của trận này hoặc ban tổ chức mới được phát.`)
};

const ko_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 경기의 심판이나 주최자만 중계할 수 있습니다.`)
};

const de_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur der Schiedsrichter dieses Spiels oder die Veranstalter dürfen es übertragen.`)
};

const ru_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслировать может только судья этого матча или организаторы.`)
};

const tr_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maçı yalnızca hakemi ya da düzenleyicileri yayınlayabilir.`)
};

const it_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo l'arbitro di questa partita o gli organizzatori possono trasmetterla.`)
};

const pl_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitować może tylko sędzia tego meczu albo organizatorzy.`)
};

const uk_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслювати може лише суддя цього матчу або організатори.`)
};

const hi_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस मैच का रेफ़री या आयोजक ही इसे प्रसारित कर सकते हैं।`)
};

const ar_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يبثّ هذه المباراة إلا حكمها أو منظّموها.`)
};

const ms_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pengadil perlawanan ini atau penganjurnya boleh menyiarkannya.`)
};

const bn_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কেবল এই খেলার রেফারি বা আয়োজকেরাই এটি সম্প্রচার করতে পারেন।`)
};

const zh_tw2_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有這場比賽的裁判或主辦單位才能轉播。`)
};

const zh_hk2_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有這場比賽的裁判或主辦單位才能轉播。`)
};

const ur_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صرف اس میچ کا ریفری یا منتظمین ہی اسے نشر کر سکتے ہیں۔`)
};

const fa_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنها داور این بازی یا برگزارکنندگان می‌توانند آن را پخش کنند.`)
};

const sw_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ni refa wa mchezo huu au waandalizi pekee wanaoweza kuurusha.`)
};

const nl_video_not_permitted = /** @type {(inputs: Video_Not_PermittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen de scheidsrechter van deze wedstrijd of de organisatoren mogen hem uitzenden.`)
};

/**
* | output |
* | --- |
* | "Only this game's referee or the people running the event can broadcast it." |
*
* @param {Video_Not_PermittedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_not_permitted = /** @type {((inputs?: Video_Not_PermittedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Not_PermittedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_not_permitted(inputs)
	if (locale === "ja") return ja_video_not_permitted(inputs)
	if (locale === "zh") return zh_video_not_permitted(inputs)
	if (locale === "es") return es_video_not_permitted(inputs)
	if (locale === "pt") return pt_video_not_permitted(inputs)
	if (locale === "id") return id_video_not_permitted(inputs)
	if (locale === "fr") return fr_video_not_permitted(inputs)
	if (locale === "tl") return tl_video_not_permitted(inputs)
	if (locale === "vi") return vi_video_not_permitted(inputs)
	if (locale === "ko") return ko_video_not_permitted(inputs)
	if (locale === "de") return de_video_not_permitted(inputs)
	if (locale === "ru") return ru_video_not_permitted(inputs)
	if (locale === "tr") return tr_video_not_permitted(inputs)
	if (locale === "it") return it_video_not_permitted(inputs)
	if (locale === "pl") return pl_video_not_permitted(inputs)
	if (locale === "uk") return uk_video_not_permitted(inputs)
	if (locale === "hi") return hi_video_not_permitted(inputs)
	if (locale === "ar") return ar_video_not_permitted(inputs)
	if (locale === "ms") return ms_video_not_permitted(inputs)
	if (locale === "bn") return bn_video_not_permitted(inputs)
	if (locale === "zh-TW") return zh_tw2_video_not_permitted(inputs)
	if (locale === "zh-HK") return zh_hk2_video_not_permitted(inputs)
	if (locale === "ur") return ur_video_not_permitted(inputs)
	if (locale === "fa") return fa_video_not_permitted(inputs)
	if (locale === "sw") return sw_video_not_permitted(inputs)
	if (locale === "nl") return nl_video_not_permitted(inputs)
	return en_video_not_permitted(inputs)
});